module.exports = __webpack_public_path__ + "img/组 126@2x(7).6c4b7c96.png";